import { cloneDeep } from 'lodash-es';
import { Pipe, PipeTransform } from '@angular/core';
import { PriceConfig, Product } from '../../../types';
import { select, Store } from '@ngrx/store';
import { ShoppingCartState } from '../../actions/standalone';
import {
  selectProductsInBasket,
  selectProductsList,
  selectProductVouchers,
} from '../../actions/selector';
import { AvailableCurrenciesService } from '../../../../../zalamo/currencies/available-currencies.service';
import { calculateProductPriceFromParams } from '../../../products-front/helpers';
import { map, switchMap } from 'rxjs';

@Pipe({
  name: 'productPriceWithVoucher',
  standalone: false,
})
export class ProductPriceWithVoucherPipe implements PipeTransform {
  productsInBasket$ = this.store.pipe(select(selectProductsInBasket));
  productsInShop$ = this.store.pipe(select(selectProductsList));
  vouchers$ = this.store.pipe(select(selectProductVouchers));
  discount: { code: string; discount: number };

  constructor(
    private store: Store<{ shoppingCart: ShoppingCartState }>,
    private availableCurrencies: AvailableCurrenciesService,
  ) {}

  transform(a: Array<PriceConfig>) {
    const value = cloneDeep(a);
    return this.productsInBasket$.pipe(
      map((productsInBasket) => ({
        productsInBasket,
      })),
      switchMap(({ productsInBasket }) =>
        this.productsInShop$.pipe(
          map((productsInShop) => ({
            productsInBasket,
            productsInShop,
          })),
        ),
      ),
      switchMap(({ productsInBasket, productsInShop }) =>
        this.vouchers$.pipe(
          map((vouchers) => ({
            productsInBasket,
            productsInShop,
            vouchers,
          })),
        ),
      ),
      map(({ productsInBasket, productsInShop, vouchers }) => {
        const allProducts: Array<Product> = [];
        productsInBasket.forEach((selected) => {
          allProducts.push(
            productsInShop.find(
              (product) => product.productId === selected.productId,
            ),
          );
        });
        const price: Array<PriceConfig> = [];
        allProducts.forEach((product, index) => {
          price.push({
            price:
              calculateProductPriceFromParams(
                product,
                productsInBasket[index].configuration,
                this.availableCurrencies.getCurrentCurrency(),
              ) * productsInBasket[index].quantity,
            code: this.availableCurrencies.getCurrentCurrency(),
          });
        });
        const allPrice: PriceConfig = { price: 0, code: '' };
        allPrice.price = price.reduce(
          (previousValue, currentValue) => previousValue + currentValue.price,
          0,
        );
        if (price.length) {
          allPrice.code = price[0].code;
          this.discount = { code: allPrice.code, discount: 0 };
          if (vouchers) {
            vouchers.forEach((voucher) => {
              if (
                voucher.price.find((x) => x.code === allPrice.code).price <=
                allPrice.price
              ) {
                this.discount.discount = voucher.percentDiscount;
                this.discount.code = allPrice.code;
              }
            });
          }
          value.forEach((value1) => {
            if (!this.discount.code) {
              this.discount = { discount: 0, code: value1.code };
            }
            value1.price -= (value1.price / 100) * this.discount.discount;
          });
        }
        return value;
      }),
    );
  }
}
